import { useEffect, useRef, useState, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../auth/useAuth';
import { useLocationsDropdown } from '../../../APIs/common';
import { ConfigContext } from '../../../contexts/ConfigContext';
import { reactSelectDark } from '../../../styles/reactSelectDarkTheme';
import './FloatingActionMenu.css';

export default function FloatingActionMenu() {
  const [open, setOpen] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const config = useContext(ConfigContext);
  const [location, setLocation] = useState(null);
  const wrapperRef = useRef(null);
  const navigate = useNavigate();
  const { user } = useAuth();
  const hasGiftcardAddon = user?.subscription?.addons;

  const { locations, isLoading: isLocationLoading } = useLocationsDropdown();
  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  const locationOptions =
    locations?.map((loc) => ({
      value: loc.id,
      label: loc.name
    })) || [];

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const proceedToScan = () => {
    if (!location) return;

    sessionStorage.setItem('selectedLocationId', location.value);

    setShowLocationModal(false);
    setOpen(false);

    navigate('/gift_card/scan');
  };

  useEffect(() => {
    if (!showLocationModal) {
      setLocation(null);
    }
  }, [showLocationModal]);

  return (
    <>
      <div className="fab-wrapper" ref={wrapperRef}>
        {open && (
          <div className="fab-menu">
            <button onClick={() => go('/booking-management/new-booking')}>
              <span className="fab-icon">📄</span>
              <span>Add Booking</span>
            </button>

            <button onClick={() => go('/gift_card/add')} disabled={!hasGiftcardAddon} className={!hasGiftcardAddon ? 'fab-disabled' : ''}>
              <span className="fab-icon">🎁</span>
              <span>Add Gift Card {!hasGiftcardAddon && <i className="ph ph-crown ms-1" style={{ color: '#f5c518' }} />}</span>
            </button>

            {/* <button onClick={() => go('/gift_card/scan')}> */}
            {/* <button
              onClick={() => {
                if (user?.role?.name === 'merchant_admin') {
                  setShowLocationModal(true);
                } else {
                  go('/gift_card/scan');
                }
              }}
            >
              <span className="fab-icon">📷</span>
              <span>Redeem</span>
            </button> */}
            <button
              disabled={!hasGiftcardAddon}
              className={!hasGiftcardAddon ? 'fab-disabled' : ''}
              onClick={() => {
                if (!hasGiftcardAddon) return;

                if (user?.role?.name === 'merchant_admin') {
                  setShowLocationModal(true);
                } else {
                  go('/gift_card/scan');
                }
              }}
            >
              <span className="fab-icon">📷</span>
              <span>Redeem {!hasGiftcardAddon && <i className="ph ph-crown ms-1" style={{ color: '#f5c518' }} />}</span>
            </button>
          </div>
        )}

        <button className="fab-main" onClick={() => setOpen(!open)}>
          +
        </button>
      </div>

      <Modal
        show={showLocationModal}
        onHide={() => setShowLocationModal(false)}
        centered
        backdrop="static"
        className="select-location-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Location</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <label className="form-label">
            Location <span className="text-danger">*</span>
          </label>

          <Select
            options={locationOptions}
            value={location}
            onChange={setLocation}
            isLoading={isLocationLoading}
            placeholder={isLocationLoading ? 'Loading locations...' : 'Select location'}
            styles={{
              menuList: (base) => ({
                ...base,
                maxHeight: 160
              }),
              ...(config.mode === 'dark' ? reactSelectDark : {})
            }}
          />

          <small className="text-muted">Redemption will be recorded under this location.</small>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setShowLocationModal(false);
              setLocation(null);
            }}
          >
            Cancel
          </Button>

          <Button variant="primary" disabled={!location} onClick={proceedToScan}>
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
